<template>
    <div class="reports-download" v-click-outside="onClickOutside">
      <div class="reports-download__header">
        <div class="reports-download__title mb-1">{{ $t('voc.queue') }}</div>
        <div class="reports-download__count">{{ completed }} {{ $t('voc.out_of') }} {{ total }}</div>
      </div>
      <template v-if="reports.length">
        <div class="reports-download__body" :key="report.id" v-for="report in reports">
          <div class="reports-download__item-process" v-if="report.status === 'in_progress'">
            {{ report.report_type }} ({{ report.generation_start }})
            <span class="loader"></span>
          </div>

          <div class="reports-download__item" v-if="report.status === 'completed'"
               @mouseover="mouseOver($event)"
               @mouseleave="mouseleave($event)"
               @click="downloadReport(report)"
          >
            <span>{{ report.report_type }} ({{ report.generation_end }})</span>
            <span>
              <img src="/images/download-report.svg" alt=""/>
          </span>
          </div>

          <div class="reports-download__item-error" v-if="report.status === 'failed'">
            <div style="font-weight: 500"><s>{{ report.report_type }} ({{ report.generation_start }})</s></div>
            <div style="font-size: 12px">{{ $t('voc.generate_report_error') }}</div>
          </div>
        </div>
      </template>
      <template class="reports-download__body" v-else>
        <div style="padding: 15px;color: rgba(143, 143, 143, 1)">
          {{ $t('voc.no_processes') }}
        </div>
      </template>
    </div>
</template>

<script>
import api from "../../api";

export default {
  name: "ReportsModal",
  props: {
    isReportsOpened: Boolean,
  },
  watch: {
    isReportsOpened: async function(val) {
      if (val) {
        await this.getReports();
        const interval = setInterval(async () => {
          if (this.isReportsOpened) {
            await this.getReports();
          } else {
            clearInterval(interval);
          }
        }, 60000);
      }
    }
  },
  data: function () {
    return {
      reports: [],
      total: 0,
      completed: 0,
      inProgress: 0,
    }
  },
  methods: {
    mouseOver(e) {
      if (e.target.children && e.target.children[1]) {
        e.target.children[1].children[0].src = '/images/download-report-clicked.svg';
      }
    },
    mouseleave(e) {
      if (e.target.children && e.target.children[1]) {
        e.target.children[1].children[0].src = '/images/download-report.svg';
      }
    },
    async getReports() {
      let reportsIcon = document.getElementById('reports-download')
      let loadingIcon = document.getElementById('reports-download-circle')

      await api.reportsList().then(response => {
        this.reports = response.data.reports;
        this.total = response.data.total;
        this.completed = response.data.completed;
        this.inProgress = response.data.in_progress;

        if (this.inProgress > 0) {
          reportsIcon.hidden = true
          loadingIcon.hidden = false
        } else {
          reportsIcon.hidden = false
          loadingIcon.hidden = true
        }
      });
    },
    downloadReport(report) {
      const link = document.createElement('a')
      link.setAttribute('href', report.report_url)
      link.setAttribute('download', report.report_type);
      link.click()
    },
    onClickOutside (event, el) {
      if (event.target.id !== 'reports-download' && event.target.id !== 'reports-download-img'
        && event.target.id !== 'reports-download-circle' && event.target.id !== 'reports-download-loading') {
        this.$emit('close-reports-modal')
      }
    },
  },
  async mounted() {
    await this.getReports();
  }
}
</script>

<style scoped>
  .reports-download {
    position: absolute;
    top: 65px;
    right: 123px;
    background: #FFFFFF;
    min-height: 130px;
    width: 376px;
    z-index: 100;
    box-shadow: 0 0 6px 0 #2125291A;
    border-radius: 0.25rem;
    border: 1px solid rgba(41, 41, 41, 0.15);
  }

  .reports-download:before {
    content: '';
    display: block;
    position: absolute;
    left: 340px;
    bottom: 100%;
    width: 0;
    height: 0;
    border: 10px solid transparent;
    border-bottom-color: rgba(41, 41, 41, 0.15);
  }

  .reports-download:after {
    content: '';
    display: block;
    position: absolute;
    left: 341px;
    bottom: 100%;
    width: 0;
    height: 0;
    border: 9px solid transparent;
    border-bottom-color: #FFFFFF;
  }

  .reports-download__header {
    border-bottom: 1px solid rgba(173, 181, 189, 0.2);
    padding: 16px
  }

  .reports-download__title {
    font-size: 16px;
    font-weight: 500;
    line-height: 21px;
    text-align: left;
  }

  .reports-download__count {
    font-size: 12px;
    font-weight: 400;
    line-height: 16px;
    text-align: left;
    color: rgba(143, 143, 143, 1);
  }

  .reports-download__body {
    padding: 10px;
  }

  .reports-download__item, .reports-download__item-process, .reports-download__item-error {
    margin-top: 10px;
    padding: 8px;
    cursor: pointer;
    min-height: 44px;
    display: flex;
    justify-content: space-between;
    font-size: 14px;
    font-weight: 400;
    line-height: 16px;
    text-align: left;

    color: rgba(33, 37, 41, 1);
  }

  .reports-download__item:first-child {
    margin-top: 0;
  }

  .reports-download__item-error {
    flex-direction: column;
    color: rgba(213, 49, 58, 1);
  }

  .reports-download__item-process {
    flex-direction: column;
    color: rgba(143, 143, 143, 1);
  }

  .reports-download__item:hover, .reports-download__item-process:hover {
    background: rgba(251, 251, 252, 1);
  }

  .reports-download__item-error:hover {
    background: rgba(251, 234, 235, 1);
  }

  .loader {
    width: 100%;
    height: 4px;
    display: inline-block;
    position: relative;
    background: rgba(245, 245, 245, 1);
    overflow: hidden;
  }
  .loader::after {
    content: '';
    width: 192px;
    height: 4px;
    background: rgba(255, 209, 118, 1);
    position: absolute;
    top: 0;
    left: 0;
    box-sizing: border-box;
    animation: animloader 1.2s linear infinite;
  }

  @keyframes animloader {
    0% {
      left: 0;
      transform: translateX(-100%);
    }
    100% {
      left: 100%;
      transform: translateX(0%);
    }
  }
</style>


